module.exports = __webpack_public_path__ + "static/media/npaLogo.3eedec80.png";